module.exports = __webpack_public_path__ + "static/media/iconWrite.8683c9d6.svg";